export default "__VITE_ASSET__5270528d__"